import React from 'react';
import { SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-2 border-coral/30 bg-carbon-soft" data-id="element-75" data-mp="3gezev8fo7z39">
      <div className="mx-auto max-w-3xl px-3 py-5 text-center sm:px-6" data-id="element-76" data-mp="3ghc4m7ro7dqv">
        <p className="text-[0.7rem] font-extrabold uppercase tracking-[0.12em] text-gold sm:text-xs" data-id="element-77" data-mp="32pff8bhdzhy6">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-2 text-[0.66rem] leading-snug text-muted sm:text-[0.7rem]" data-id="element-78" data-mp="3ueiltxwqx4dz">
          Sistema Lower Body 360°™ es un producto educativo de entrenamiento
          general. No sustituye evaluación, diagnóstico, tratamiento ni
          seguimiento médico, fisioterapéutico, nutricional o de un profesional
          del ejercicio cualificado. Los ejercicios y recomendaciones deben
          adaptarse a la experiencia, condición física y circunstancias
          individuales. Ante lesión, embarazo, dolor agudo o persistente,
          enfermedad o síntomas inusuales, busca orientación profesional
          adecuada.
        </p>
        <p className="mt-2 text-[0.7rem] text-beige sm:text-xs" data-id="element-79" data-mp="3la27uq37evt4">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-coral underline underline-offset-2" data-id="element-80" data-mp="3gbqxme8zyjad">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p className="mt-1 text-[0.68rem] text-muted sm:text-xs" data-id="element-81" data-mp="3q724kae5ym7k">
          Términos y Condiciones • Política de Privacidad • Contacto
        </p>
      </div>
    </footer>;
}